import React from 'react';
import { CTAButton } from './CTAButton';
import { Star, ShieldCheck } from 'lucide-react';
export function Hero() {
  return <section className="pt-8 pb-12 px-4 bg-brand-light relative overflow-hidden border-b-8 border-brand-green" data-id="element-95">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-96">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-brand-green border-2 border-brand-dark text-white font-bold text-xs sm:text-sm mb-6 shadow-md uppercase tracking-widest" data-id="element-97">
          SISTEMA DI YOGA VALIDATO
        </div>

        <h1 className="text-3xl sm:text-5xl md:text-6xl font-black text-brand-dark leading-tight mb-4 tracking-tight uppercase" data-id="element-98">
          Il Sistema di Pianificazione Completo per Insegnanti di Yoga
        </h1>

        <p className="text-base sm:text-xl text-brand-dark font-medium leading-relaxed mb-8 max-w-3xl mx-auto" data-id="element-99">
          Risparmia ore di pianificazione, offri sessioni migliori e insegna con
          sicurezza — senza creare ogni sequenza da zero.
        </p>

        <div className="mb-8" data-id="element-100">
          <a href="https://yoga-pro.impultienda.ar/checkout" className="block cursor-pointer relative group" data-id="element-101">
            <img src="https://cdn.magicpatterns.com/uploads/qeCtvuEY2ns3jiGzLBrkca/ChatGPT-Image-24-jun-2026_-10_01_02-p.m..webp" alt="YOGA PRO 6-in-1 Box Set" className="w-full h-auto object-contain max-w-md sm:max-w-2xl mx-auto hover:scale-[1.02] transition-transform duration-500 drop-shadow-2xl relative z-10" data-id="element-102" />
          </a>
        </div>

        <div className="mb-6" data-id="element-103">
          <CTAButton className="max-w-xl mx-auto" data-id="element-104">
            🚀 SÌ, VOGLIO IL MIO SISTEMA ORA
          </CTAButton>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-sm text-brand-dark font-bold" data-id="element-105">
          <div className="flex items-center gap-1.5" data-id="element-106">
            <Star className="w-5 h-5 fill-brand-gold text-brand-gold" data-id="element-107" />
            <span data-id="element-108">4.9/5 — Recensioni Professionali Verificate</span>
          </div>
          <span className="hidden sm:inline text-gray-400" data-id="element-109">•</span>
          <div className="flex items-center gap-1.5" data-id="element-110">
            <ShieldCheck className="w-5 h-5 text-brand-green" data-id="element-111" />
            <span data-id="element-112">Garanzia 7 Giorni — Zero Rischio</span>
          </div>
        </div>
      </div>
    </section>;
}